<template>
    <div class="h-screen flex items-center justify-center px-4">
        <slot />
    </div>
</template>
